import { ProtectiveFunctionLocation } from "./models/protectiveFunctionLocation";
import { PSF_ProtectiveFunctionComments } from "./models/PSF_ProtectiveFunctionComments";

export const ccfByLocation = (location: ProtectiveFunctionLocation, psf: PSF_ProtectiveFunctionComments) => {
    switch (location) {
        case "INP1": return psf.input1CCF;
        case "INP2": return psf.input2CCF;
        case "INP3": return psf.input3CCF;
        case "INP4": return psf.input4CCF;
        case "INP5": return psf.input5CCF;
        case "A1O1": return psf.action1CCF;
        case "A1O2": return psf.action2CCF;
        case "A1O3": return psf.action3CCF;
        case "A1O4": return psf.action4CCF;
        case "A1O5": return psf.action5CCF;
        default:
            // should never get here
            return null;
    }
}

export const votingConfigByLocation = (location: ProtectiveFunctionLocation, psf: PSF_ProtectiveFunctionComments) => {
  switch (location) {
    case "INP1": return psf.input1Config;
    case "INP2": return psf.input2Config;
    case "INP3": return psf.input3Config;
    case "INP4": return psf.input4Config;
    case "INP5": return psf.input5Config;
    case "A1O1": return psf.action1Config;
    case "A1O2": return psf.action2Config;
    case "A1O3": return psf.action3Config;
    case "A1O4": return psf.action4Config;
    case "A1O5": return psf.action5Config;
    default:
      // should never get here
      return null;
  }
}

export const updateCcfByLocation = (newCcf: number, location: ProtectiveFunctionLocation, oldPsf: PSF_ProtectiveFunctionComments) => {
    // this is a little clunky
    const updatedPsf = { ... oldPsf };
    switch (location) {
        case "INP1":
            updatedPsf.input1CCF = newCcf;
            break;
        case "INP2":
            updatedPsf.input2CCF = newCcf;
            break;
        case "INP3":
            updatedPsf.input3CCF = newCcf;
            break;
        case "INP4":
            updatedPsf.input4CCF = newCcf;
            break;
        case "INP5":
            updatedPsf.input5CCF = newCcf;
            break;
        case "A1O1":
            updatedPsf.action1CCF = newCcf;
            break;
        case "A1O2":
            updatedPsf.action2CCF = newCcf;
            break;
        case "A1O3":
            updatedPsf.action3CCF = newCcf;
            break;
        case "A1O4":
            updatedPsf.action4CCF = newCcf;
            break;
        case "A1O5":
            updatedPsf.action5CCF = newCcf;
            break;
        default:
            break;
    }

    return updatedPsf;
}

export const updateVotingConfigByLocation = (newVoting: string, location: ProtectiveFunctionLocation, oldPsf: PSF_ProtectiveFunctionComments) => {
  // this is a little clunky
  const updatedPsf = { ...oldPsf };
  switch (location) {
    case "INP1":
      updatedPsf.input1Config = newVoting;
      break;
    case "INP2":
      updatedPsf.input2Config = newVoting;
      break;
    case "INP3":
      updatedPsf.input3Config = newVoting;
      break;
    case "INP4":
      updatedPsf.input4Config = newVoting;
      break;
    case "INP5":
      updatedPsf.input5Config = newVoting;
      break;
    case "A1O1":
      updatedPsf.action1Config = newVoting;
      break;
    case "A1O2":
      updatedPsf.action2Config = newVoting;
      break;
    case "A1O3":
      updatedPsf.action3Config = newVoting;
      break;
    case "A1O4":
      updatedPsf.action4Config = newVoting;
      break;
    case "A1O5":
      updatedPsf.action5Config = newVoting;
      break;
    default:
      break;
  }

  return updatedPsf;
}